import { IUser, UserRoleTypes, userHasRoles } from '@solomonicuk/core-sdk';

export const userIsReviewPublisher = (user: IUser) =>
  userHasRoles(user, [UserRoleTypes.ReviewPublisher]);
